import { Injectable } from '@angular/core'
import { Observable } from 'rxjs'
import { ApiService } from './api.service'

@Injectable()
export class TratamentoConvenioService {
    constructor(
        private apiService: ApiService
    ) {}

    post(form) : Observable<any> {
        return this.apiService.post('/tratamento-convenio', form)
    }
    
    getAll( idTratamento? ): Observable<any> {
        let url : string = `/tratamento-convenio`
        return this.apiService.get(url, idTratamento)
    }

    get(id: string): Observable<any> {
        let url : string = `/tratamento-convenio/${id}`
        return this.apiService.get(url)
    }

    put(id: string, form) : Observable<any> {
        form._method = 'PUT'
        return this.apiService.post('/tratamento-convenio/'+id, form)
    }

    delete(id) {
        return this.apiService.delete('/tratamento-convenio/'+id)
    }

}